import React from 'react';
import { IconArrowTop } from '@bynder/icons';
import styled from 'styled-components';
import { Button, token, Tooltip } from '@bynder/design-system';
import { useTranslate } from '@bynder/localization';
import { StyledButtonBackground } from './styled-components/ButtonBackground';

type Props = {
  containerRef: React.MutableRefObject<HTMLElement | null>;
};

const ScrollToTopButton: React.FC<Props> = ({ containerRef }) => {
  const { translate } = useTranslate();
  const onClickHandler = () => {
    if (!containerRef?.current) return;

    containerRef.current.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  };

  return (
    <StyledScrollTopContainer>
      <Tooltip content={translate('SCROLL_TO_TOP_BUTTON.TOOLTIP')}>
        <StyledButtonBackground>
          <Button
            isSmall
            variant="clean"
            icon={<IconArrowTop />}
            aria-label="Back to top"
            onClick={onClickHandler}
          />
        </StyledButtonBackground>
      </Tooltip>
    </StyledScrollTopContainer>
  );
};

const StyledScrollTopContainer = styled.div`
  position: absolute;
  right: ${token.spacing6};
  bottom: ${token.spacing6};
  z-index: 2;
`;

export default ScrollToTopButton;
